import { createSelector } from 'reselect';

const menuSelector = (state) => state.menu;

export const authVisibility = createSelector(menuSelector, (menu) => menu.authVisibility);
